import { useMutation } from "@tanstack/react-query";
import { createCheckoutSession } from "api-client";
import { useTranslation } from "react-i18next";
import { useToast } from "ui";

export function useCreateCheckoutSession() {
  const toast = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (params: { priceId: string }) => {
      const response = await createCheckoutSession({
        body: { priceId: params.priceId },
      });
      return response.data.data;
    },
    onSuccess: (data) => {
      window.location.href = data.url;
    },
    onError: (error) => {
      toast.toast({
        title: t("billing.checkoutError"),
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
